import type { SyncStatus } from '@wiztime/sync';
import { SyncUiState } from '../lib/syncState';
import { useTranslation } from 'react-i18next';

/** One line describing the sync status for tooltips: "Synced · Last sync: 10/7/2026, 4:30 PM". */
export function useSyncStatusText(status: SyncStatus): string {
  const { t, i18n } = useTranslation();
  const parts: string[] = [t(`sync.state.${status.state}`)];
  if (status.lastError !== null && status.state !== SyncUiState.Offline)
    parts.push(t(`sync.error.${status.lastError}`));
  parts.push(
    status.lastSyncAt === null
      ? t('sync.neverSynced')
      : t('sync.lastSync', { time: new Date(status.lastSyncAt).toLocaleString(i18n.language) }),
  );
  return parts.join(' · ');
}
